import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { Random } from '../../../Utility/Random';
import { cardsHelper } from '../CardReducer';
import { CardTask } from '../CardTasks';
import { DEFAULT_CARD_HEIGHT, DEFAULT_CARD_WIDTH } from '../../../Prototype/Level/Card/ICardData';
import { SCORE_PLUS_THREE_CARD, SCORE_PLUS_THREE_NEW_CARD } from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { ICardsState } from '../ICardState';
import { initialCardStateData } from '../initialCardStateData';
import { CardState } from 'Prototype/Level/Card/CardState';
import CardStateModifierHelper from '../CardStateModifierHelper';

export default class PlusThreeCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = getCardsState(state);
        const currentCardState = CardStateHelper.getCardState(state, this.cardID);

        const targets: string[] = [];

        if (currentCardState === CardState.IN_PLAY) {
            // Discard this card.
            state = CardStateHelper.updateGameState(state, cardsState);
            state = CardStateHelper.setCardDiscarded(state, this.cardID);
            cardsState = getCardsState(state);

            // Add three new cards to the stack.
            for (let i = 0; i < 3; i++) {
                const newCardID = `card_${Random.ID()}`;
                cardsState = CardStateHelper.addCard(cardsState, {
                    ...initialCardStateData,
                    id: newCardID,
                    type: CardType.value,
                    faceUp: false,
                    depth: 0,
                    rotation: 0,
                    modifiers: [],
                    sequence: 0,
                    attempts: 0,
                    value: cardsHelper.draw(),
                    random: true,
                    x: 0,
                    y: 0,
                    width: DEFAULT_CARD_WIDTH,
                    height: DEFAULT_CARD_HEIGHT,
                });
                cardsState = CardStateHelper.setCardInStack(cardsState, newCardID);
                targets.push(newCardID);
            }
        }

        // Add score.
        const scores: number[] = [SCORE_PLUS_THREE_CARD, ...Array(targets.length).fill(SCORE_PLUS_THREE_NEW_CARD)];
        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger plus three cards animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.PLUS_THREE,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.updateCards(state);
        state = CardStateModifierHelper.onCardPlayed(state, this.cardID);

        return state;
    }
}
